import { p as palette } from '../base/color-ec580bc4.js';
import { s as spacing, m as mobileSpacing } from '../base/spacing-b4d393ed.js';
import { d as fontSizes, l as link, m as mobileFontSizes } from '../base/typography-dd13a6be.js';

const tagStyles = {
  fontSize: fontSizes.tiny,
  fontWeight: 'bold',
  letterSpacing: '1px',
  lineHeight: '12px',
  padding: '0 3px 1px 3px',
  radius: '1px',
  bottomOffset: '2px',
  backgroundDefault: link.color,
  backgroundNew: '#018485',
  backgroundBeta: palette.gray[700],
  backgroundInfo: palette.blue[700],
  backgroundError: palette.red[600],
  backgroundWarning: palette.clementine[700],
  backgroundSuccess: palette.green[700],
  color: palette.white,
  margin: `0 ${spacing.mini}`
};
const mobileTagStyles = {
  mobile: {
    fontSize: mobileFontSizes.tiny,
    lineHeight: '14px',
    margin: `0 ${mobileSpacing.mini}`
  }
};

export { mobileTagStyles as m, tagStyles as t };
//# sourceMappingURL=tag-208660fb.js.map
